import React, { useState } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { Button, Modal } from 'react-bootstrap';
import { IoClose } from 'react-icons/io5';
import { forgotPassowrdValidateSchema } from '../../../utils/yupSchemas/ResgistrationSchema';
import Busy from '../../../assets/gif/busy.gif';
import callBackendAPI from '../../../utils/callBackendAPI';
import { toast } from 'react-toastify';
import { toastDefaults } from '../../../utils/ToastOptionCommon';
import { error } from 'console';
import '../../SignUp/form/SignupForm.scss';

interface IProps {
  onModalClosed: () => void;
  submitHandler: () => void;
}

const ForgotPasswordForm = (props: IProps) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: any) => {
    try {
      setLoading(true);
      const response = await callBackendAPI(
        'POST',
        'auth/forgotPassword',
        null,
        {
          email: values.email,
        }
      );
      if (response.error) {
        toast.error(response.error, toastDefaults());
      } else {
        toast.success(
          'Email sent successfully. Please check your inbox.',
          toastDefaults()
        );
        props.submitHandler();
      }
    } catch (error) {
      toast.error('Error occured', toastDefaults());
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal className="auth-modal" show={true} centered>
        <Modal.Header>
          <div className="modal-header-content">
            <Modal.Title>Forgot password</Modal.Title>
            <p className="modal-subtitle">
              Enter your email to receive a password reset link
            </p>
          </div>
          <div
            onClick={props.onModalClosed}
            className="icons8-close ms-auto"
            aria-label="Close"
          >
            <IoClose />
          </div>
        </Modal.Header>

        <Formik
          initialValues={{ email: '' }}
          enableReinitialize
          validationSchema={forgotPassowrdValidateSchema}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          <Form noValidate>
            <Modal.Body>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email Address
                </label>
                <Field
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  className="form-control"
                  placeholder="name@example.com"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="invalid-feedback d-block"
                />
              </div>

              <Button
                type="submit"
                className="btn-primary w-100 py-2 mt-3 mb-2"
                disabled={loading}
              >
                {loading && (
                  <img
                    src={Busy}
                    alt="Loading..."
                    className="me-2 spinner-gif"
                  />
                )}
                Send Reset Link
              </Button>

              <div className="text-center mt-3">
                <a
                  role="button"
                  onClick={props.onModalClosed}
                  className="small fw-semibold"
                >
                  Back to Sign In
                </a>
              </div>
            </Modal.Body>
          </Form>
        </Formik>
      </Modal>
    </>
  );
};

export default ForgotPasswordForm;
